import React from "react";
import Hero from "../components/Hero";
import StatsSection from "../components/StatsSection";
import AboutUs from "../components/AboutUs";
import AboutIsland from "../components/AboutIsland";
import Testimonials from "../components/Testimonials";
import SalesAgent from "../components/SalesAgent";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <div className="Home">
      <Hero />
      <StatsSection />
      <AboutUs />
      <AboutIsland />
      <Testimonials />
      <SalesAgent />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
